<template>
  <div v-if="hasAnyPermission('notification-templates-view')" class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />
    <div class="card">
      <div class="card-header py-3">
        <div class="row align-items-center">
          <!-- Bagian H3 di Kiri -->
          <div class="col-4">
            <h5 class="mb-0">Notification Template</h5>
          </div>

          <!-- Bagian Pencarian di Tengah -->
          <div class="col-4 d-flex justify-content-center">
            <IconField class="w-100">
              <InputIcon class="pi pi-search" />
              <InputText
v-model="table.search" type="text" size="small" placeholder="Search Description"
                class="rounded-pill w-100" @keyup="filter" />
            </IconField>
          </div>

          <!-- Bagian Button di Kanan -->
          <div class="col-4 text-end">
            <button v-if="hasAnyPermission('notification-templates-create')" type="button" class="mx-1 mb-0 btn btn-sm btn-primary" @click="openAddModal">Add</button>
          </div>
        </div>
      </div>
      <div style="height: 500px; overflow-y: auto">
        <DataTable :value="table.data" removable-sort scrollable scroll-height="flex" table-style="min-width: 75rem">
          <Column header="Code" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.code }}</span>
            </template>
          </Column>
          <Column header="Description" :style="{ width: '150px' }" :body-style="{ width: '150px', padding: '0' }" header-class="bg-light" sortable>
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.description }}</span>
            </template>
          </Column>
          <Column header="Mail Template" :style="{ width: '150px' }" :body-style="{ width: '150px', padding: '0' }" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ formatMailType(row.data.mail_type) }}</span>
            </template>
          </Column>
          <Column header="Target Url" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.target_url }}</span>
            </template>
          </Column>
          <Column :style="{ width: '100px' }" :body-style="{ width: '100px', padding: '0' }" header-class="bg-light">
            <template #body="row">
              <div v-if="!table.onLoad">
                <ButtonPrime
v-if="hasAnyPermission('notification-templates-update')" v-tooltip.bottom="'Update'" icon="pi pi-pencil" outlined rounded size="small"
                  @click="openEditModal(row.data)" />
                <ButtonPrime
v-if="hasAnyPermission('notification-templates-delete')" v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger"
                  size="small" style="margin-left: 5px;" @click="deleteItem(row.data.id)" />
              </div>
              <div v-else class="m-4"><span /></div>
            </template>
          </Column>
          <template #empty>
            <div style="text-align: center; padding: 35px 0;">
              <img src="/no_data.png" alt="No Data" style="width: 330px; height: 330px; opacity: 0.7;" />
              <p class="text-muted mt-2">No Notif found</p>
            </div>
          </template>
        </DataTable>
      </div>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination
v-model="table.page.current_page" :page-count="table.page.total_page" size="sm"
          @click="changePage()" />
        <p>
          {{ (table.page.current_page - 1) * table.page.per_page + table.data.length }}
          of {{ table.total }}
        </p>
      </div>
    </div>

    <DialogPrime v-model:visible="modal.visible" :header="modal.title" style="width: 35rem; margin: 10px;">
      <div class="mb-2">
        <label for="code" class="font-semibold">Code <span class="text-danger">*</span></label>
        <InputText
id="code" v-model="modal.data.code" placeholder="Code"
          :class="`${(modal.errorMessage['code'] && modal.data.code == '') ? 'border-danger' : ''}`"
          fluid :disabled="modal.action === 'edit'" @input="toUpperCaseVal($event, 'code')" />
        <small v-if="modal.errorMessage['code'] && modal.data.code == ''" class="text-danger">{{
          modal.errorMessage['code']
        }}</small>
      </div>

      <div class="mb-2">
        <label for="description" class="font-semibold">Description <span class="text-danger">*</span></label>
        <InputText
id="description" v-model="modal.data.description" placeholder="Description"
          :class="`${(modal.errorMessage['description'] && modal.data.description == '') ? 'border-danger' : ''}`"
          fluid />
        <small v-if="modal.errorMessage['description'] && modal.data.description == ''" class="text-danger">{{
          modal.errorMessage['description'] }}</small>
      </div>

      <div class="mb-2">
        <label for="subject" class="font-semibold">Subject <span class="text-danger">*</span></label>
        <InputText
id="subject" v-model="modal.data.subject" placeholder="Subject"
          :class="`${(modal.errorMessage['subject'] && modal.data.subject == '') ? 'border-danger' : ''}`" fluid />
        <small v-if="modal.errorMessage['subject'] && modal.data.subject == ''" class="text-danger">{{
          modal.errorMessage['subject'] }}</small>
      </div>

      <div class="mb-2">
        <label for="notif_message" class="font-semibold">Notif Message <span class="text-danger">*</span></label>
        <PrimeTextarea
id="notif_message" v-model="modal.data.notif_message" rows="5" cols="30"
          :invalid="modal.errorMessage['notif_message'] && !modal.data.notif_message" style="resize: none;"
          placeholder="Enter Message" fluid />
        <small v-if="modal.errorMessage['notif_message'] && modal.data.notif_message == ''" class="text-danger">{{
          modal.errorMessage['notif_message'] }}</small>
      </div>

      <div class="mb-2">
        <label for="wa_message" class="font-semibold">WA Message <span class="text-danger">*</span></label>
        <InputText
id="wa_message" v-model="modal.data.wa_message" placeholder="Message"
          :class="`${(modal.errorMessage['wa_message'] && modal.data.wa_message == '') ? 'border-danger' : ''}`"
          fluid />
        <small v-if="modal.errorMessage['wa_message'] && modal.data.wa_message == ''" class="text-danger">{{
          modal.errorMessage['wa_message'] }}</small>
      </div>

      <div class="mb-2">
        <label for="mail_type" class="font-semibold">Mail Type <span class="text-danger">*</span></label>
        <SelectPrime
id="mail_type" v-model="modal.data.mail_type" :options="optMailType" option-label="label"
          option-value="value" placeholder="Please choose Mail Type"
          :invalid="modal.errorMessage['mail_type'] && modal.data.mail_type === ''" class="w-full md:w-56" fluid />
        <small v-if="modal.errorMessage['mail_type'] && modal.data.mail_type == ''" class="text-danger">{{
          modal.errorMessage['mail_type'] }}</small>
      </div>

      <div class="mb-2">
        <label for="mail_template" class="font-semibold">Mail Template <span class="text-danger">*</span></label>
        <div id="editor" ref="editor" style="height: 300px;"></div>
        <small v-if="modal.errorMessage['mail_template'] && !modal.data.mail_template" class="text-danger">{{
          modal.errorMessage['mail_template'] }}</small>
      </div>

      <div class="mb-2">
        <label for="source" class="font-semibold">Source <span class="text-danger">*</span></label>
        <PrimeTextarea
id="source" v-model="modal.data.source" rows="5" cols="30"
          :invalid="modal.errorMessage['source'] && !modal.data.source" style="resize: none;"
          placeholder='{"target_table": "", "relations": []}' fluid />
        <small v-if="modal.errorMessage['source'] && !modal.data.source" class="text-danger">{{
          modal.errorMessage['source'] }}</small>
      </div>

      <div class="">
        <label for="target_url" class="font-semibold">Target Url <span class="text-danger">*</span></label>
        <InputText
id="target_url" v-model="modal.data.target_url" placeholder="Target Url"
          :class="`${(modal.errorMessage['target_url'] && modal.data.target_url == '') ? 'border-danger' : ''}`"
          fluid />
        <small v-if="modal.errorMessage['target_url'] && modal.data.target_url == ''" class="text-danger">{{
          modal.errorMessage['target_url'] }}</small>
      </div>

      <template #footer>
        <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
          <ButtonPrime
type="button" label="Cancel" severity="danger" class="px-4 border-0" raised size="small"
            :disabled="modal.onLoading" @click="modal.visible = false"></ButtonPrime>
          <ButtonPrime
v-if="canSaveTemplate" type="button" severity="contrast" raised size="small" label="Save" class="px-4" :disabled="modal.onLoading || anyEmptyVal"
            @click="save()">
            <template v-if="modal.onLoading" #icon>
              <i class="fas fa-spinner fa-spin me-2"></i>
            </template>
          </ButtonPrime>
        </div>
      </template>
    </DialogPrime>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import api from "@/helpers/api";
import notificationTemplateService from "@/services/generalSettings/notificationTemplateService"
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import NoAccess from "@/components/NoAccess.vue";

export default {
  components: { NoAccess },
  data() {
    return {
      table: {
        search: this.$route.query.description || "",
        onLoad: false,
        total: 3,
        data: [{}],
        page: {
          current_page: 1,
          total_page: 1,
        },
        limit: 100,
      },
      modal: {
        visible: false,
        action: "",
        title: "",
        data: {},
        errorMessage: {},
        onLoading: false,
      },
      optMailType: [{ label: "HTML Template", value: "script" }, { label: "Plain Text", value: "plain_text" }],
      quillEditor: null,
    };
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    anyEmptyVal() {
      return (!this.modal.data.code || !this.modal.data.description || !this.modal.data.mail_type || !this.modal.data.subject || !this.modal.data.notif_message || !this.modal.data.wa_message || !this.modal.data.mail_template || !this.modal.data.target_url);
    },
    canSaveTemplate() {
      return this.modal.action === 'create'
        ? this.hasAnyPermission('notification-templates-create')
        : this.hasAnyPermission('notification-templates-update');
    }
  },
  watch: {
    'modal.visible'(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.initQuillEditor();
        });
      } else {
        this.destroyQuillEditor();
      }
    }
  },
  mounted() {
    if (this.hasAnyPermission('notification-templates-view')) {
      this.get()
    }
  },
  methods: {
    hasAnyPermission(...perms) {
      return perms.some((p) => this.authUserPermissions.includes(p));
    },
    initQuillEditor() {
      const editorElement = this.$refs.editor;
      if (!editorElement) return;

      if (this.quillEditor) {
        const toolbar = this.$el.querySelector('.ql-toolbar');
        if (toolbar) toolbar.remove();
        this.quillEditor = null;
      }

      this.quillEditor = new Quill(editorElement, {
        theme: 'snow',
        placeholder: 'Enter Mail Template content...',
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link', 'image'],
            ['clean']
          ]
        }
      });

      // Set initial content
      let hasContent = false;
      if (this.modal.data.source) {
        try {
          const sourceContent = typeof this.modal.data.source === 'string' ? JSON.parse(this.modal.data.source) : this.modal.data.source;
          // Cek apakah ini format Delta (Quill internal)
          if (sourceContent && Array.isArray(sourceContent.ops)) {
            this.quillEditor.setContents(sourceContent);
            hasContent = true;
          }
        } catch (e) {
          // Bukan JSON atau bukan Delta, abaikan
        }
      }

      // Jika belum ada konten dari source (Delta), pakai mail_template (HTML)
      if (!hasContent && this.modal.data.mail_template && this.modal.data.mail_template !== '<p><br></p>') {
        this.quillEditor.clipboard.dangerouslyPasteHTML(this.modal.data.mail_template);
      }

      // Force check placeholder visibility
      if (this.quillEditor.getLength() > 1) {
        this.quillEditor.root.classList.remove('ql-blank');
      }

      // Listen to changes
      this.quillEditor.on('text-change', () => {
        this.modal.data.mail_template = this.quillEditor.root.innerHTML;
        this.modal.editorDelta = this.quillEditor.getContents(); 
        if (this.modal.errorMessage['mail_template']) {
          delete this.modal.errorMessage['mail_template'];
        }
      });
    },
    destroyQuillEditor() {
      if (this.quillEditor) {
        this.quillEditor = null;
        const toolbar = this.$el.querySelector('.ql-toolbar');
        if (toolbar) toolbar.remove();
      }
    },
    async get() {
      this.table.onLoad = true
      try {
        const response = await api(this, notificationTemplateService.list({ limit: this.table.limit, page: this.table.page.current_page, description: this.table.search }), false);

        this.table.data = response.data.data;
        this.table.total = response.data.total;
        this.table.page = response.data;
        this.table.page.total_page = response.data.last_page
        // console.log("page", this.table.page);
      } catch (error) {
        this.table.data = []
        this.table.total = 0
      } finally {
        this.table.onLoad = false
      }
    },
    openAddModal() {
      this.modal.action = "create";
      this.modal.title = "Add Notification Template";
      this.modal.data = {
        code: "", description: "", mail_type: "", subject: "", notif_message: "",
        wa_message: "", mail_template: "", target_url: "", 
        source: JSON.stringify({ target_table: "", relations: [] }, null, 2)
      };
      this.modal.errorMessage = {};
      this.modal.onLoading = false;
      this.modal.visible = true;
    },
    openEditModal(item) {
      this.modal.action = "edit";
      this.modal.title = "Edit Notification Template";
      this.modal.data = { 
        ...item,
        source: item.source ? (typeof item.source === 'string' ? item.source : JSON.stringify(item.source, null, 2)) : ""
      };
      this.modal.errorMessage = {};
      this.modal.onLoading = false;
      this.modal.visible = true;
    },
    deleteItem(id) {
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          this.table.onLoad = true
          api(this, notificationTemplateService.delete(id)).then(() => { this.get() });
        }
      });
    },
    save() {
      let isValid = true;
      const requiredField = [
        { key: "code", message: "Code" }, 
        { key: "description", message: "Description" }, 
        { key: "mail_type", message: "Mail Type" }, 
        { key: "subject", message: "Subject" }, 
        { key: "notif_message", message: "Notif Message" }, 
        { key: "wa_message", message: "WA Message" }, 
        { key: "mail_template", message: "Mail Template" }, 
        { key: "source", message: "Source" },
        { key: "target_url", message: "Target Url" }
      ];
      requiredField.forEach((val) => {
        if (!this.modal.data[val.key]) {
          this.modal.errorMessage[val.key] = `${val.message} is required`;
          isValid = false;
        }
      })
      if (!isValid) return false;

      this.modal.onLoading = true
      
      // Persiapkan payload
      let finalSource = this.modal.data.source;
      try {
        if (typeof finalSource === 'string') {
          finalSource = JSON.parse(finalSource);
        }
      } catch (e) {
        // Jika gagal parse, kirim apa adanya (string)
      }

      const payload = {
        ...this.modal.data,
        source: finalSource
      };

      setTimeout(async () => {
        try {
          if (this.modal.action === 'create') {
            await api(this, notificationTemplateService.create(payload));
          } else if (this.modal.action === 'edit') {
            await api(this, notificationTemplateService.update(this.modal.data.id, payload))
          }
          this.modal.data = {};
          this.modal.visible = false;
          this.get();
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.modal.onLoading = false
        }
      }, 500)
    },
    filter() {
      if (this.table.search != this.$route.query.description) {
        setTimeout(() => {
          if (this.table.search.length > 3) {
            this.table.search = this.table.search.toUpperCase()
            this.$router.push({ name: 'Notification Templates', params: { moduleSlug: 'material-management' }, query: { description: this.table.search }, });
          } else {
            this.$router.push({ name: 'Notification Templates', params: { moduleSlug: 'material-management' } });
          }

          this.get();
        }, 500)
      }
    },
    changePage() {
      this.table.onLoad = true;
      setTimeout(() => {
        this.get();
      }, 100);
    },
    toUpperCaseVal(event, key) {
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;

      const upper = input.value.toUpperCase();
      this.modal.data[key] = upper;

      this.$nextTick(() => {
        input.setSelectionRange(start, end);
      });
    },
    handleErrorObjectNested(error) {
      if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
        const errorData = error.response?.data?.data;

        if (typeof errorData === 'object' && errorData !== null) {
          for (const key in errorData) {
            if (Object.prototype.hasOwnProperty.call(errorData, key)) {
              const match = key.match(/^items\.(\d+)\.(.+)$/);
              if (match) {
                error.response.data.data[key].forEach(message => {
                  this.$toastNotifPrime('error', error.response.data.message, `${message} in row ${parseInt(match[1]) + 1}`)
                })
              } else {
                this.$toastNotifPrime('error', error.response.data.message, errorData[key]);
                // errorData[key].forEach(message => {
                //   this.$toastNotifPrime('error', error.response.data.message, message);
                // });
              }
            }
          }
        }
      }
    },
    formatMailType(val) {
      return val === 'script' ? "HTML Template" : (val === 'plain_text' ? "Plain Text" : "");
    }
  },
};
</script>
